import React from 'react';
import Icon from '../../../components/AppIcon';

const DateRangeFilter = ({ startDate, endDate, onStartDateChange, onEndDateChange, onExport }) => {
  return (
    <div className="card-elevated">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-4 flex-1">
          <div className="flex-1">
            <label className="block text-sm font-interface font-medium text-muted-foreground mb-2">
              Start Date
            </label>
            <div className="relative">
              <input
                type="date"
                value={startDate}
                onChange={(e) => onStartDateChange(e?.target?.value)}
                className="w-full px-4 py-2 pl-10 bg-input border border-border rounded-lg font-interface text-foreground focus:ring-2 focus:ring-ring focus:outline-none"
              />
              <Icon 
                name="Calendar" 
                size={18} 
                color="var(--color-muted-foreground)" 
                className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
              />
            </div>
          </div>

          <div className="flex-1">
            <label className="block text-sm font-interface font-medium text-muted-foreground mb-2">
              End Date
            </label>
            <div className="relative">
              <input
                type="date"
                value={endDate}
                onChange={(e) => onEndDateChange(e?.target?.value)}
                className="w-full px-4 py-2 pl-10 bg-input border border-border rounded-lg font-interface text-foreground focus:ring-2 focus:ring-ring focus:outline-none"
              />
              <Icon 
                name="Calendar" 
                size={18} 
                color="var(--color-muted-foreground)" 
                className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
              />
            </div>
          </div>
        </div>

        <button
          onClick={onExport}
          className="flex items-center justify-center gap-2 px-6 py-2 bg-primary text-primary-foreground rounded-lg font-interface font-medium hover:opacity-90 transition-opacity lg:self-end"
        >
          <Icon name="Download" size={18} />
          Export Data
        </button>
      </div>
    </div>
  );
};

export default DateRangeFilter;